import { Select, Form, Button, message } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  getSubjects,
  getTeachers,
  bindStudentsToSubject,
  getTeacherSubjects,
  getStudentsList,
} from '../../../actions';

function StudentsToSubject() {
  const [teachers, setTeachers] = useState();
  const [subjects, setSubjects] = useState();
  const [teacherSubjects, setTeacherSubjects] = useState();
  const [currentSelected, setCurrentSelected] = useState({ teacherId: null, subjectId: null });
  const [students, setStudents] = useState();
  const [bind, setBind] = useState({ studentIdList: [], teacherSubjectId: null });
  const [form] = Form.useForm();

  useEffect(() => {
    getTeachers().then(({ data }) => setTeachers(data));
    getSubjects().then(({ data }) => setSubjects(data));
    getTeacherSubjects().then(({ data }) => setTeacherSubjects(data));
    getStudentsList().then(({ data }) => setStudents(data));
  }, []);

  const teachersWithSubjects =
    teachers &&
    teachers.filter(
      (teacher) =>
        teacherSubjects &&
        teacherSubjects
          .map((tSub) => {
            return tSub.teacherId;
          })
          .includes(teacher.id),
    );

  const teachersSubject =
    teacherSubjects &&
    teacherSubjects
      .filter((subject) => subject.teacherId === currentSelected.teacherId)
      .map((sub) => {
        return sub.subjectId;
      });

  const filteredSubjects =
    subjects && subjects.filter((sub) => teachersSubject && teachersSubject.includes(sub.id));

  const onBindStudents = () => {
    bindStudentsToSubject(bind)
      .then(() => {
        message.success('Успешно обновлено', 4);
      })
      .catch(() => {
        message.error('Что-то пошло не так,повторите попытку', 4);
      });
    form.resetFields();
  };

  return (
    <React.Fragment>
      <h1> Привязка студентов к предметам</h1>
      <Form form={form} layout="inline">
        <Form.Item name="teacherId" label="Учитель">
          <Select
            allowClear={true}
            showSearch={true}
            onChange={(e, data) => {
              setCurrentSelected({ ...currentSelected, teacherId: data.value });
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 200 }}
            placeholder="Выберите учителя">
            {teachersWithSubjects &&
              teachersWithSubjects.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {`${el.firstName} ${el.middleName} ${el.lastName}`}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item name="subjectIdList" label="Список предметов" style={{ marginLeft: '60px' }}>
          <Select
            disabled={!currentSelected.teacherId}
            showSearch={true}
            allowClear={true}
            onChange={(value) => {
              setCurrentSelected({ ...currentSelected, subjectId: value });
              setBind({
                ...bind,
                teacherSubjectId: teacherSubjects.find(
                  (ts) => ts.teacherId === currentSelected.teacherId && ts.subjectId === value,
                ).id,
              });
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 600 }}
            placeholder="Выберите предметы">
            {filteredSubjects &&
              filteredSubjects.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.descriptionQaz}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item name="studentsList" label="Список студентов" style={{ marginTop: '20px' }}>
          <Select
            disabled={!currentSelected.teacherId}
            mode="multiple"
            showSearch={true}
            allowClear={true}
            onChange={(value) => {
              setBind({ ...bind, studentIdList: value });
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: 600 }}
            placeholder="Выберите учеников">
            {students &&
              students.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {`${el.firstName} ${el.middleName} ${el.lastName}`}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item style={{ marginTop: 50, marginLeft: 50 }}>
          <Button type="primary" onClick={onBindStudents}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </React.Fragment>
  );
}

export default StudentsToSubject;
